import React, { useEffect, ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { Outlet, RouteProps, useNavigate } from 'react-router-dom'
import { RootState } from 'store'
import { Entity, CrudAction, usePermissions } from 'utils/hooks'

type ProtectedRoute = {
  permissionKey: Entity
  requiredAction?: CrudAction
  children?: ReactNode
} & RouteProps

export const PermissionsRouteGuard: React.FC<ProtectedRoute> = ({
  permissionKey,
  requiredAction = CrudAction.GET,
  children,
}) => {
  const navigate = useNavigate()
  const permissions = useSelector(
    (state: RootState) => state.permissions?.permissions
  )

  const { checkPermission } = usePermissions()
  const permissionsReady = permissions?.[permissionKey] !== undefined
  const hasPermission = checkPermission(permissionKey, requiredAction)

  useEffect(() => {
    if (permissionsReady && !hasPermission) {
      navigate('/no-permission', { replace: true })
    }
  }, [permissionsReady, hasPermission, navigate])

  if (!permissionsReady || !hasPermission) return null

  return children ? <>{children}</> : <Outlet />
}
